<template>
  <section class="table">
    <!-- ewallet table -->
    <el-table
      v-if="tableData.length"
      :data="tableData"
      :show-header="false"
      style="width: 100%"
      :row-class-name="'table-pointer'"
      :header-row-class-name="'tableHeader'"
      @row-click="rowClick">
      <el-table-column
        width="69px"
        align="center">
        <template>
          <div class="flex-algin">
            <font-awesome-icon
              icon="file-powerpoint"
              class="icon-color green"/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="160px"
        prop="created_at"
        label="Updated">
        <template #default="{ row }">
          <div class="flex-algin time-text">
            <span>{{ row.sort_time.split(" ")[0] }}</span><br>
            <span> {{ row.sort_time.split(" ")[1] }}</span>
          </div>
          <div class="flex-algin">
            <span>
              <div class="flex  table-icon">
                <div>
                  <span
                    v-tooltip="row.company_language"
                    class="icon icon-content"
                  >
                    <img
                      :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                    >
                  </span>
                </div>
                <div>
                  <span
                    v-tooltip="row.class_language"
                    class="icon icon-content"
                  >
                    <font-awesome-icon
                      v-if="row.class_id"
                      :icon="getOptionName('iconOptions', row.class_id)" />
                  </span>
                </div>
              </div>
              <div class="flex table-icon margin-top-flex">
                <div>
                  <span
                    v-if="(Array.isArray(row.extra_benefits) && row.extra_benefits.includes(2)) && extra_show(row.extra_benefits_content,2)==2"
                    v-tooltip="extra_tip(row.extra_benefits_content,2)"
                    class="icon icon-content backgroud-width"
                  >
                    <font-awesome-icon
                      icon="wind" />
                  </span>
                </div>
                <div>
                  <span
                    v-if="Array.isArray(row.extra_benefits) && row.extra_benefits.includes(1) && extra_show(row.extra_benefits_content,1)==1"
                    v-tooltip="extra_tip(row.extra_benefits_content,1)"
                    class="icon icon-content backgroud-width"
                  >
                    <font-awesome-icon
                      icon="user-injured" />
                  </span>
                </div>
              </div>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Plan Name">
        <template #default="{ row }">
          <span class="span-label">
            <router-link
              class="showLink"
              :to="rowClickFn(row)">
              {{ row.plan }}
            </router-link>
          </span>
          <p
            v-if="row.pcy_no||row.cvr_nt_no"
            class="phone-text">
            <span  v-if="row.pcy_no"><span class="weight-text">Policy No. </span> {{ row.pcy_no }}&nbsp;&nbsp;&nbsp;</span>
            <span  v-if="row.cvr_nt_no"><span class="weight-text">Cert </span> {{ row.cvr_nt_no }}</span>
          </p>
          <span
            v-if="row.order_sn"
            class="phone-text">
            <template><span class="weight-text"> Ref. </span>{{ row.order_sn }}</template>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="assigne"
        width="130px"
        label="Assignee">
        <template #default="{ row }">
          <div class="flex-algin">
            <p class="first-text">{{ row.isrd_nm }} </p>
            <span></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="221px"
        label="Summary & Status">
        <template #default="{ row }">
          <div class="flex-algin">
            <p class="first-text summary">{{ row.description }} </p>
            <p class="first-text summary">{{ row.policy_period }} </p>
            <p
              v-if="row.source_language"
              class="channel">{{row.source_language}}</p>
          </div>
          <div class="flex-algin status-height">
            <p>
              <span
                class="span-status green">
                {{ row.pcy_stts_language }}
              </span>
            </p>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- coupon record -->
    <div class="coupon-list">
      <div
        v-for="(item, i) in couponData"
        :key="i"
        class="item flex"
        :class="{
          'pointer': item.used_times>0
        }"
        @click="couponClick(item)">
        <div class="left">
          <p class="title">{{item.title}}</p>
          <p class="money">{{item.fixed_amount | formatMoney(2, true)}}</p>
        </div>
        <div class="right">
          <div class="status">
            <span
              class="span-status"
              :class="{
                'green': item.used_times>0,
                'yellow-dark': item.used_times == 0
              }">
              {{ item.used_times > 0? 'Used' : 'Unused' }}
            </span>
          </div>
          <div
            v-if="item.used_times>0"
            class="policy">Policy Ref <router-link
              :to="linkToPolicy(item)"
              class="num">{{item.order_sn}}</router-link></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'PoliciesTab',
  mixins: [MixinOptions,MixinFormat],
  props: {
    detailData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
    }
  },
  computed: {
    extra_show(){
      return (row,index)=>{
        let textData = {}
        if(!row) return ''
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        return textData.id
      }
    },
    extra_tip(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        if(textData)
          return textData.name

      }
    },
    tableData(){
      if(this.detailData.ewallet_data){
        return Array(this.detailData.ewallet_data) || []
      }
      return []
    },
    couponData(){
      return this.detailData.coupon_record || []
    }
  },
  methods: {
    rowClick(row) {
      const {id, product_id, pcy_id} = row
      this.$router.push({
        path: product_id > 90? '/records/micropolicy/detail' : product_id > 50? '/records/policy/manual/detail' :'/records/policy/detail',
        query: {
          id,
          product_id,
          pcy_id
        }
      })
    },
    rowClickFn(row){
      if(row){
        const {id, product_id, pcy_id} = row
        return({
          path: product_id > 90? '/records/micropolicy/detail' : product_id > 50? '/records/policy/manual/detail' :'/records/policy/detail',
          query: {
            id,
            product_id,
            // pcy_id
          }
        })
      }
    },

    couponClick(item){
      if(item.used_times > 0){
        const {order_id, product_id} = item
        this.$router.push({
          path: '/records/quote/detail',
          query: {
            order_id,
            product_id
          }
        })
      }
    },

    linkToPolicy({order_id, product_id}){
      return ({
        path: '/records/quote/detail',
        query: {
          order_id,
          product_id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table {
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
  }
  .span-status, .span-options {
    display: inline-block;
    //margin-right: 15px;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    //text-overflow: ellipsis;
    //width: 120px;
    max-width: 160px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .flex-algin {
    &.time-text{
      font-size: 12px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .channel{
      font-size: 12px;
      font-weight: 600;
      color: #586069;
      margin: 5px 0;
      height: 18px;
      line-height: 18px;
    }
    .status-height{
      height: 23px;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  .weight-text{
    font-weight: 600;
  }
  .showLink{
    text-decoration: none;
    font-weight: 600;
    color: #24292E;
    &:hover{
      color:  #0366D6;
    }
  }
  

  /deep/ .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        margin-right: 15px;
        .cell{
          line-height: 23px;
          position: relative;
          height: inherit;
          padding: 0;
        }
      }
    }
    .table-pointer{
      cursor: pointer;
    }
  }
  
  /deep/ .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
  }

  .coupon-list{
    margin-top: 30px;
    .pointer{
      cursor: pointer;
    }
    .item{
      padding: 10px 15px;
      justify-content: space-between;
      border: 1px solid #D1D5DA;
      border-radius: 6px;
      .left{
        display: flex;
        flex-direction: column;
        color: #24292E;
        .title{
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
        }
        .money{
          font-weight: 400;
          font-size: 12px;
        }
      }
      .right{
        display: flex;
        flex-direction: column;
        justify-content: center;
        .status{
          text-align: right;
        }
        .policy{
          margin-top: 6px;
          color: #586069;
          font-weight: 600;
          font-size: 12px;
          .num{
            text-decoration: none;
          }
        }
      }
      & + .item {
        margin-top: 20px;
      }
    }
  }
}
</style>
